var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from 'react';
import * as ServiceCollaborateur from '../../services/collaborateur';
import { EditionCollaborateur } from './EditionCollaborateur';
import { Activite } from '../activite/Activite';
import { Affaire } from '../affaire/Affaire';
import { Document } from '../document/Document';
import { Objectif } from '../objectif/Objectif';
import { Loader } from '../../utils/Loader';
import { MapData, MapRedirection } from '../../utils/MapData';
import { Card, Stack, Tab, Tabs, Chip, Grid } from '@mui/material';
import { CardTitle } from '../../utils/CardTitle';
import { CollaborateurIcon, DeleteIcon, EmailIcon, MobileIcon, PhoneIcon, } from '../../utils/Icons';
import { Definitions } from '../../utils/Definitions';
import { Button } from '../../utils/Button';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { Typography } from '../../utils/Typography';
import { IconButton } from '../../utils/IconButton';
import { getIsMobile, getOriginalUser } from '../../services/utilisateur';
import { classChipInHeader } from '../../utils/Classes';
import { Error, isError } from '../error/Error';
var originalUser = getOriginalUser();
export var FicheCollaborateur = function (props) {
    var CollaborateurId = props.CollaborateurId;
    var isMobile = getIsMobile();
    var _a = useState(0), navigationSelected = _a[0], setNavigationSelected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), collaborateur = _c[0], setCollaborateur = _c[1];
    var canEditCollaborateur = originalUser.CanEditCollaborateur;
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var newCollaborateur;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceCollaborateur.getCollaborateur(CollaborateurId)];
                case 1:
                    newCollaborateur = _a.sent();
                    setCollaborateur(newCollaborateur);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        getData();
    }, []);
    if (!collaborateur || loading) {
        return _jsx(Loader, {});
    }
    if (isError(collaborateur)) {
        return _jsx(Error, __assign({}, collaborateur));
    }
    if (!CollaborateurId) {
        return _jsx(Error, { status: 401 });
    }
    var renderTitle = function () {
        return (_jsx(CardTitle, { withFileAriane: true, datas: {
                CollaborateurId: collaborateur.IdCollaborateur,
                CollaborateurName: collaborateur.getLibelle,
            }, color: "collaborateur", startIcon: _jsx(CollaborateurIcon, {}), renderButtons: function () { return (_jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [_jsx(Chip, { sx: classChipInHeader(), color: collaborateur.Actif ? 'success' : 'error', label: collaborateur.Actif ? 'Actif' : 'Désactivé' }), canEditCollaborateur && (_jsx(_Fragment, { children: _jsx(EditionCollaborateur, { CollaborateurId: collaborateur.IdCollaborateur, onChange: function () { return getData(); } }) }))] }))); } }));
    };
    var handleClickDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes vous sûr de vouloir supprimer le collaborateur ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceCollaborateur.deleteCollaborateur(CollaborateurId)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var navigations = [
        {
            label: 'Affaires',
            component: function () { return (_jsx(Affaire, { CollaborateurId: CollaborateurId, CanAddAffaire: false })); },
        },
        {
            label: 'Activités',
            component: function () { return _jsx(Activite, { CollaborateurId: CollaborateurId }); },
        },
    ];
    if (originalUser.Licence.UseDocument) {
        navigations.push({
            label: 'Documents',
            component: function () { return (_jsx(Document, { Model: "Collaborateur", ModelId: CollaborateurId, CanEditDocument: canEditCollaborateur })); },
        });
    }
    if (!originalUser.Licence.UseVision ||
        originalUser.IsAdministrateur ||
        originalUser.VisibiliteCollaborateurIds.includes(CollaborateurId)) {
        navigations.push({
            label: 'Objectifs',
            component: function () { return _jsx(Objectif, { CollaborateurId: CollaborateurId }); },
        });
    }
    var renderCollaborateur = function () {
        var adresse = [
            collaborateur.Adresse,
            collaborateur.CodePostal,
            collaborateur.Ville,
            collaborateur.intitule_pays ? collaborateur.intitule_pays.Libelle : '',
        ]
            .filter(function (value) { return value; })
            .join(' ');
        return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsxs(Grid, __assign({ container: true, spacing: isMobile ? 0 : 2, p: 1 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: [_jsx(Definitions, { datas: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (collaborateur.Email
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Envoyer un mail", color: "primary", href: "mailto:".concat(collaborateur.Email) }, { children: _jsx(EmailIcon, {}) })) }, { children: collaborateur.Email }))),
                                        },
                                    ]
                                    : []), true), (collaborateur.Telephone
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro fixe", color: "primary", href: "tel:".concat(collaborateur.Telephone) }, { children: _jsx(PhoneIcon, {}) })) }, { children: collaborateur.Telephone }))),
                                        },
                                    ]
                                    : []), true), (collaborateur.Mobile
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro mobile", color: "primary", href: "tel:".concat(collaborateur.Mobile) }, { children: _jsx(MobileIcon, {}) })) }, { children: collaborateur.Mobile }))),
                                        },
                                    ]
                                    : []), true), [
                                    {
                                        label: 'Type',
                                        value: collaborateur.collaborateur_type
                                            ? collaborateur.collaborateur_type.Libelle
                                            : '-',
                                    },
                                ], false) }), _jsx(Definitions, { datas: __spreadArray(__spreadArray(__spreadArray([
                                    {
                                        value: (_jsxs(Stack, __assign({ alignItems: "center", direction: "row" }, { children: [_jsx(MapRedirection, { queries: [adresse] }), adresse] }))),
                                    }
                                ], (collaborateur.Latitude && collaborateur.Longitude
                                    ? [
                                        {
                                            value: (_jsx("div", { children: _jsx(MapData, { libelle: adresse, Latitude: collaborateur.Latitude, Longitude: collaborateur.Longitude }) })),
                                        },
                                    ]
                                    : []), true), (collaborateur.TagsObject &&
                                    collaborateur.TagsObject.length > 0
                                    ? [
                                        {
                                            value: (_jsx(Stack, __assign({ direction: isMobile ? 'column' : 'row', spacing: 2 }, { children: collaborateur.TagsObject.map(function (tag) { return (_jsx(Chip, { color: "info", label: tag.label }, tag.value)); }) }))),
                                        },
                                    ]
                                    : []), true), (collaborateur.Commentaire
                                    ? [
                                        {
                                            label: 'Commentaire',
                                            valueUnder: true,
                                            value: (_jsx("p", __assign({ className: "pre-line" }, { children: collaborateur.Commentaire }))),
                                        },
                                    ]
                                    : []), true) })] })), _jsxs(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: [_jsx(Tabs, __assign({ variant: "scrollable", allowScrollButtonsMobile: true, value: navigationSelected, onChange: function (e, newValue) { return setNavigationSelected(newValue); } }, { children: navigations.map(function (navigation, index) { return (_jsx(Tab, { label: navigation.label }, index)); }) })), navigations[navigationSelected].component()] }))] })) })));
    };
    return (_jsxs(_Fragment, { children: [renderTitle(), renderCollaborateur(), canEditCollaborateur && (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsx(Stack, __assign({ direction: "row", justifyContent: "center", alignItems: "center", padding: 2 }, { children: _jsx(Button, __assign({ color: "error", onClick: function () { return handleClickDelete(); }, startIcon: _jsx(DeleteIcon, {}) }, { children: "Supprimer le collaborateur" })) })) })))] }));
};
//# sourceMappingURL=FicheCollaborateur.js.map